<template>
  <v-container fluid>
    <v-data-table dense :items="items" :headers="headers" :loading="loading" :hide-default-header="hideHeader"
      hide-default-footer disable-pagination disable-filtering disable-sort :items-per-page="itemsPerPage" item-key="id"
      loading-text="Загрузка данных..." no-data-text="Нет данных..." no-results-text="Совпадений не найдено..."
      class="styled-table">
      <template v-slot:[`item.createTimeStamp`]="{ item }">
        {{ item.createTimeStamp | dateTimeFormat }}
      </template>

      <template v-slot:[`item.carTimeIn`]="{ item }">
        {{ item.carTimeIn | dateTimeFormat }}
      </template>

      <template v-slot:[`item.carNumber`]="{ item }">
        {{ item.carCountry.name }} {{ item.carNumber }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex justify-space-between">
          <v-tooltip v-if="canEdit" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="editCar(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Изменить</span>
          </v-tooltip>

          <v-tooltip v-if="canLeave" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="info" v-bind="attrs" v-on="on" @click="leaveCar(item)">
                mdi-check-all
              </v-icon>
            </template>
            <span>Обработана</span>
          </v-tooltip>

          <v-tooltip v-if="canDelete" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="red" v-bind="attrs" v-on="on" @click="deleteCar(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>

    <!-- место для кнопки добавить -->
    <v-sheet height="64" />
    <!-- кнопка добавить -->
    <v-btn v-if="canAdd" bottom right color="primary" dark fab fixed to="/carQueueItem">
      <v-icon class="white--text">
        mdi-plus
      </v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    itemsPerPage: Number.MAX_SAFE_INTEGER,
    items: [],
    loading: false,
    cargoType: 0, // любой
    headers: [
      { text: "Операция", value: "carOperationType.name", class: "tableHeader tableHeaderText--text" },
      { text: "№ машины", value: "carNumber", class: "tableHeader tableHeaderText--text" },
      { text: "Водитель", value: "driver", class: "tableHeader tableHeaderText--text" },
      { text: "Тел. водителя", value: "driverPhone", class: "tableHeader tableHeaderText--text" },
      { text: "Регистрация", value: "createTimeStamp", class: "tableHeader tableHeaderText--text" },
      { text: "Въезд", value: "carTimeIn", class: "tableHeader tableHeaderText--text" },
      { text: "Статус", value: "carStatus.name", class: "tableHeader tableHeaderText--text" }
    ]
  }),

  computed: {
    hideHeader: function () {
      return this.$vuetify.breakpoint.xsOnly
    },

    canAdd: function () {
      return this.$store.state.auth.user.role !== "Клиент" && this.$store.state.auth.user.role !== "Кладовщик"
    },

    canDelete: function () {
      return this.$store.state.auth.user.role === "Управляющий" || this.$store.state.auth.user.role === "Администратор"
    },

    canLeave: function () {
      return this.$store.state.auth.user.role === "Управляющий" || this.$store.state.auth.user.role === "Администратор" || this.$store.state.auth.user.role === "Кладовщик"
    },

    canEdit: function () {
      return this.$store.state.auth.user.role !== "Клиент"
    }
  },

  created() {
    this.init()

    // столбец с типом груза только для тех, кто видит разные
    if (!this.$store.state.auth.user.cargoTypeID) {
      this.headers.unshift({ text: "Тип груза", value: "cargoType.name", class: "tableHeader tableHeaderText--text" })
    }
    // столбец с действиями только для тех, кто может
    if (this.canDelete || this.canEdit) {
      this.headers.push({
        text: "",
        value: "actions",
        sortable: false,
        width: "104px",
        class: "tableHeader tableHeaderText--text",
        align: "center"
      })
    }

    document.addEventListener("keydown", this.keydown)

    // Сигналы
    this.$signals.on("CarNotify", this.onCarNotify)
    this.$signals.on("CarQueue_Delete", this.onCarQueue_Delete)
    this.$signals.on("CarQueue_Insert", this.onCarQueue_Insert)
    this.$signals.on("CarQueue_Update", this.onCarQueue_Update)
    this.$signals.on("CarQueue_UpdateTimeAndStatus", this.onCarQueueUpdateTimeAndStatus)
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.keydown)

    this.$signals.off("CarNotify", this.onCarNotify)
    this.$signals.off("CarQueue_Delete", this.onCarQueue_Delete)
    this.$signals.off("CarQueue_Insert", this.onCarQueue_Insert)
    this.$signals.off("CarQueue_Update", this.onCarQueue_Update)
    this.$signals.off("CarQueue_UpdateTimeAndStatus", this.onCarQueueUpdateTimeAndStatus)
  },

  methods: {
    onCarNotify(message, cargoTypeID) {
      // пользователь не должен видеть машины других клиентов
      if (this.$store.state.auth.user.cargoTypeID != null && this.$store.state.auth.user.cargoTypeID !== cargoTypeID) {
        return
      }
      this.$notify("info", message)
    },

    onCarQueue_Delete(id) {
      this.deleteItem(id)
    },

    onCarQueue_Insert(id, cargoTypeID) {
      // кому не надо это видеть - не надо делать Get
      if (this.$store.state.auth.user.cargoTypeID != null && this.$store.state.auth.user.cargoTypeID !== cargoTypeID) {
        return
      }
      this.axios.get(`/carQueue/get/${id}`).then((response) => {
        this.items.push(response.data)
        this.sort()
      })
    },

    // изменились данные машины, статус и время здесь не могут изменяться
    // но в теории может изменяться заявка со статусом обработано
    onCarQueue_Update(id, cargoTypeID) {
      // кому не надо это видеть - не надо делать Get, надо удалить из списка запись, если она есть (изменился cargoTypeID)
      if (this.$store.state.auth.user.cargoTypeID != null && this.$store.state.auth.user.cargoTypeID !== cargoTypeID) {
        this.deleteItem(id)
        return
      }
      this.axios.get(`/carQueue/get/${id}`).then((response) => {
        if (response.data) {
          // если не было - добавляем (возможно такое если изменился cargoTypeID), если элемент был - изменяем
          const index = this.items.findIndex((el) => el.id === id)
          if (index === -1) {
            // если не было и статус обработано, то игнор
            if (response.data.carStatusID !== 100) {
              this.items.push(response.data)
              this.sort()
            }
          } else {
            // если была, но статус обработано, то удалить из списка
            if (response.data.carStatusID === 100) {
              this.deleteItem(response.data.id)
            } else {
              // update
              this.items = this.items.map((x) => (x.id === response.data.id ? response.data : x))
            }
          }
        }
      })
    },

    onCarQueueUpdateTimeAndStatus(id, cargoTypeID, newCarStatusID, carTimeIn) {
      // кому не надо это видеть - не надо ничего менять
      if (this.$store.state.auth.user.cargoTypeID != null && this.$store.state.auth.user.cargoTypeID !== cargoTypeID) {
        return
      }
      // если элемент был - изменяем
      const car = this.items.find((el) => el.id === id)
      if (car) {
        // если была, но статус обработано, то удалить из списка
        if (newCarStatusID === 100) {
          this.deleteItem(id)
        } else {
          // update
          car.carStatusID = newCarStatusID
          car.carStatus = this.$store.getters["directories/getCarStatus"](newCarStatusID)
          if (carTimeIn) {
            car.carTimeIn = carTimeIn
          }
        }
      }
    },

    // сортировка по createTimeStamp
    sort() {
      this.items.sort(function (a, b) {
        // сначала по статусу
        if (a.carStatusID != b.carStatusID) return b.carStatusID - a.carStatusID
        // потом по времени
        if (a.createTimeStamp > b.createTimeStamp) return 1
        if (a.createTimeStamp < b.createTimeStamp) return -1
        // равно => тогда по id
        return a.id - b.id
      })
    },

    async init() {
      this.loading = true
      await this.axios
        .get("/carQueue/get")
        .then((response) => {
          this.items = response.data
          this.sort()
        })
        .catch((error) => {
          const err = error.response?.data ? error.response.data : error
          this.$router.push(`/error?message=Ошибка при загрузке очереди машин&&error=${err}`)
        })
      this.loading = false
    },

    deleteItem(itemID) {
      const index = this.items.findIndex((el) => el.id === itemID)
      if (index !== -1) this.items.splice(index, 1)
    },

    keydown(value) {
      if (value.code === "NumpadAdd" && this.canAdd) {
        this.$router.push("/carQueueItem")
      }
    },

    async deleteCar(car) {
      if (
        !(await this.$messageBox(
          `Удалить машину номер <span class="accent--text">${car.carNumber}</span>, водитель <span class="accent--text">${car.driver}</span> из очереди?`
        ))
      ) {
        return
      }
      this.loading = true
      this.axios
        .delete(`/carQueue/delete/${car.id}`)
        .then(() => {
          this.$signals.invoke("CarQueue_Delete", car.id)
          this.deleteItem(car.id)
        })
        .finally(() => {
          this.loading = false
        })
    },

    editCar(car) {
      this.$router.push(`/carQueueItem/${car.id}`)
    },

    async leaveCar(car) {
      if (
        !(await this.$messageBox(
          `Машина <span class="accent--text">${car.carNumber}</span>, водитель <span class="accent--text">${car.driver}</span> покинула склад?`
        ))
      ) {
        return
      }
      this.loading = true
      this.axios
        .patch(`/carQueue/carLeave/${car.id}`)
        .then(() => {
          // сигнал с id изменённой записи, чтобы остальные протянули изменения
          this.$signals.invoke("CarQueue_Update", car.id, car.cargoTypeID)
          this.$signals.invoke(
            "CarNotify",
            `Машина ${car.carNumber} (${car.driver}) обработана (покинула склад)`,
            car.cargoTypeID
          )
          this.deleteItem(car.id)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>